import { render, staticRenderFns } from "./detalheCompras.vue?vue&type=template&id=3cd08f24&scoped=true"
import script from "./detalheCompras.vue?vue&type=script&lang=js"
export * from "./detalheCompras.vue?vue&type=script&lang=js"
import style0 from "./detalheCompras.vue?vue&type=style&index=0&id=3cd08f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd08f24",
  null
  
)

export default component.exports